export const IP_ORDER_OPTIONS = [
  { key: "http", translation: "http" },
  { key: "socks5", translation: "socks5" }
]
